import { SPORT_OPTIONS } from 'modules/jogador/home/content';
import { cn } from 'shared/utils/cn';

interface SportFilterBarProps {
  selectedSportId: string;
  onSelect: (sportId: string) => void;
}

export function SportFilterBar({ selectedSportId, onSelect }: SportFilterBarProps) {
  return (
    <div className="mx-auto flex max-w-7xl flex-wrap gap-3 px-4">
      {SPORT_OPTIONS.map((sport) => {
        const isSelected = sport.id === selectedSportId;

        return (
          <button
            key={sport.id}
            type="button"
            onClick={() => onSelect(sport.id)}
            className={cn(
              'flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors',
              isSelected
                ? 'border-primary bg-primary text-surface'
                : 'border-border text-ink-secondary hover:border-primary'
            )}
          >
            <span className={cn('h-2.5 w-2.5 rounded-full', sport.dotClassName)} />
            {sport.label}
          </button>
        );
      })}
    </div>
  );
}
